/*eslint-disable*/
import { mapState } from 'vuex';

export default {
    props: {
        opponent: {
            type: Object,
            default: null,
        },
        calculatingAnswers: {
            type: Boolean,
            default: false,
        },
        userScore: {
            type: Number,
            default: 0,
        },
        opponentScore: {
            type: Number,
            default: 0,
        },
        isLastGameInBattle: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        if (this.isBattle) {
            this.$emit('componentMounted');
        }
    },
    watch: {
        userScore() {
            this.$createjs.Sound.play('success');
        },
        opponentScore() {
            this.$createjs.Sound.play('failure');
        },
    },
    data() {
        return {
            opponentNumbers: [],
            isOpponentAnswering: false,
        };
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
        }),
        isBattle() {
            return this.gameType === 'battle';
        },
        opponentInfoText() {
            return this.opponent && `${this.opponent.fullName} (${this.opponent.city})`;
        },
    },
};
